import {InstitutionGraphQL} from '../../graphql-fragments/institutions/__generated/InstitutionGraphQL';

// Stripping __typename manually here instead of using WithoutTypenames because the latter does not handle
// arrays of primitives and InstitutionGraphQL has arrays of strings
export type Institution = Omit<InstitutionGraphQL, '__typename'>;

export default {
  USER_SUPPLIED_ID_PREFIX: 'inst_user:',
};
